import CallHistorySkeleton from 'flow/components/loaders/CallHistorySkeleton';

const CallHistorySkeletonV2 = () => (
    <div className="pt-3">
        <CallHistorySkeleton />
    </div>
);

export default CallHistorySkeletonV2;
